import React, { useRef, useState, useEffect } from "react";

export const AnalysisLoading = () => {
    const topLineTexts = [
        "Reviewing how you approached each scenario…",
        "Identifying patterns in how you make decisions.",
        "Bringing those patterns together into personal insights.",
        "Preparing a clear view of your leadership tendencies.",
    ];

    const containerRef = useRef<HTMLDivElement>(null);

    const [currentTextIdx, setCurrentText] = useState(0);

    useEffect(() => {
        const el = containerRef.current;
        if (!el) return;

        const handleAnimationIteration = () => {
            setCurrentText(prev => (prev + 1) % topLineTexts.length);
        };

        el.addEventListener("animationiteration", handleAnimationIteration);

        return () => {
            el.removeEventListener("animationiteration", handleAnimationIteration);
        };

        // eslint-disable-next-line
    }, []);

    return (
        <div className='mbts_analysis__loading'>
            <p className='text-lg text-medium mb-xs text-center color--txt-secondary'>
                Our analysis engine is at work. This may take up to 2 minutes 😄
            </p>
            <p className='text-lg mb-5xl text-center color--txt-disabled'>
                If you see a blank screen, please refresh the page and wait for results.
            </p>
            <div className="mbts_analysis__loading__fading_sec" ref={containerRef}>
                <p className='mbts_analysis__loading__top_line'>
                    {topLineTexts[currentTextIdx]}
                </p>
                <div className='mbts_analysis__loading__divider' />
                <p className="mbts_analysis__loading__bottom_line">
                    This simulation looks at patterns, not isolated responses.
                </p>
            </div>
        </div>
    );
};